var _a, _b;
import { __extends } from "tslib";
import { EventDispatcher, AbstractionBase } from '@awayjs/core';
import { StageEvent } from '@awayjs/stage';
import { RenderEntity } from './base/RenderEntity';
import { View, ViewEvent, PickGroup } from '@awayjs/view';
import { DefaultRenderer } from './DefaultRenderer';
import { DepthRenderer } from './DepthRenderer';
import { DistanceRenderer } from './DistanceRenderer';
var DefaultRendererPool = /** @class */ (function () {
    function DefaultRendererPool(renderGroup) {
        this.id = AbstractionBase.ID_COUNT++;
        this.renderGroup = renderGroup;
    }
    Object.defineProperty(DefaultRendererPool.prototype, "materialClassPool", {
        get: function () {
            return DefaultRendererPool._materialClassPool;
        },
        enumerable: true,
        configurable: true
    });
    DefaultRendererPool.prototype.requestAbstraction = function (asset) {
        return DefaultRenderer;
    };
    /**
     *
     * @param imageObjectClass
     */
    DefaultRendererPool.registerMaterial = function (renderMaterialClass, materialClass) {
        DefaultRendererPool._materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DefaultRendererPool._materialClassPool = new Object();
    return DefaultRendererPool;
}());
var DepthRendererPool = /** @class */ (function () {
    function DepthRendererPool(renderGroup) {
        this.id = AbstractionBase.ID_COUNT++;
        this.renderGroup = renderGroup;
    }
    Object.defineProperty(DepthRendererPool.prototype, "materialClassPool", {
        get: function () {
            return DepthRendererPool._materialClassPool;
        },
        enumerable: true,
        configurable: true
    });
    DepthRendererPool.prototype.requestAbstraction = function (asset) {
        return DepthRenderer;
    };
    /**
     *
     * @param imageObjectClass
     */
    DepthRendererPool.registerMaterial = function (renderMaterialClass, materialClass) {
        DepthRendererPool._materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DepthRendererPool._materialClassPool = new Object();
    return DepthRendererPool;
}());
var DistanceRendererPool = /** @class */ (function () {
    function DistanceRendererPool(renderGroup) {
        this.id = AbstractionBase.ID_COUNT++;
        this.renderGroup = renderGroup;
    }
    Object.defineProperty(DistanceRendererPool.prototype, "materialClassPool", {
        get: function () {
            return DistanceRendererPool._materialClassPool;
        },
        enumerable: true,
        configurable: true
    });
    DistanceRendererPool.prototype.requestAbstraction = function (asset) {
        return DistanceRenderer;
    };
    /**
     *
     * @param imageObjectClass
     */
    DistanceRendererPool.registerMaterial = function (renderMaterialClass, materialClass) {
        DistanceRendererPool._materialClassPool[materialClass.assetType] = renderMaterialClass;
    };
    DistanceRendererPool._materialClassPool = new Object();
    return DistanceRendererPool;
}());
export var RendererType;
(function (RendererType) {
    RendererType[RendererType["DEFAULT"] = 0] = "DEFAULT";
    RendererType[RendererType["DEPTH"] = 1] = "DEPTH";
    RendererType[RendererType["DISTANCE"] = 2] = "DISTANCE";
})(RendererType || (RendererType = {}));
/**
 * @class away.pool.RenderGroup
 */
var RenderGroup = /** @class */ (function (_super) {
    __extends(RenderGroup, _super);
    /**
     * //TODO
     *
     * @param materialClassGL
     */
    function RenderGroup(view, rendererType) {
        var _this = _super.call(this) || this;
        _this._mappers = new Array();
        _this._materialPools = new Object();
        _this.id = AbstractionBase.ID_COUNT++;
        _this.view = view;
        _this.stage = view.stage;
        _this.pickGroup = PickGroup.getInstance(view);
        _this._rendererPool = new RenderGroup._rendererPool[rendererType](_this);
        _this._materialClassPool = _this._rendererPool.materialClassPool;
        if (rendererType != RendererType.DEFAULT) //set shadow renderer backgrounds to white
            _this.view.backgroundColor = 0xFFFFFF;
        _this._onSizeInvalidateDelegate = function (event) { return _this.onSizeInvalidate(event); };
        _this._onContextUpdateDelegate = function (event) { return _this.onContextUpdate(event); };
        _this.stage.addEventListener(StageEvent.CONTEXT_CREATED, _this._onContextUpdateDelegate);
        _this.stage.addEventListener(StageEvent.CONTEXT_RECREATED, _this._onContextUpdateDelegate);
        _this.view.addEventListener(ViewEvent.INVALIDATE_SIZE, _this._onSizeInvalidateDelegate);
        return _this;
    }
    RenderGroup.clearAllInstances = function () {
        for (var key in this._instancePool) {
            this._instancePool[key].clearAll();
            delete this._instancePool[key];
        }
    };
    RenderGroup.getInstance = function (view, rendererType) {
        var group = this._instancePool[rendererType][view.id];
        /**
         * @todo Remove me for prevent leaks
         */
        return this._instancePool[rendererType][view.id] || (this._instancePool[rendererType][view.id] = new RenderGroup(view, rendererType));
    };
    RenderGroup.clearInstance = function (view, rendererType) {
        var renderGroup = this._instancePool[rendererType][view.id];
        if (renderGroup) {
            renderGroup.clearAll();
            delete this._instancePool[rendererType][view.id];
        }
    };
    Object.defineProperty(RenderGroup.prototype, "depthRenderGroup", {
        get: function () {
            if (this._depthRenderGroup == null)
                this._depthRenderGroup = RenderGroup.getInstance(new View(null, this.stage), RendererType.DEPTH);
            return this._depthRenderGroup;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RenderGroup.prototype, "distanceRenderGroup", {
        get: function () {
            if (this._distanceRenderGroup == null)
                this._distanceRenderGroup = RenderGroup.getInstance(new View(null, this.stage), RendererType.DISTANCE);
            return this._distanceRenderGroup;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clears the resources used by the RenderGroup.
     */
    RenderGroup.prototype.clearAll = function () {
        this.stage.removeEventListener(StageEvent.CONTEXT_CREATED, this._onContextUpdateDelegate);
        this.stage.removeEventListener(StageEvent.CONTEXT_RECREATED, this._onContextUpdateDelegate);
        this.view.removeEventListener(ViewEvent.INVALIDATE_SIZE, this._onSizeInvalidateDelegate);
    };
    RenderGroup.prototype.update = function (partition) {
        //update mappers
        var len = this._mappers.length;
        for (var i = 0; i < len; i++)
            this._mappers[i].update(partition, this);
    };
    RenderGroup.prototype.invalidate = function () {
        this._invalid = true;
    };
    RenderGroup.prototype._addMapper = function (mapper) {
        if (this._mappers.indexOf(mapper) != -1)
            return;
        this._mappers.push(mapper);
    };
    RenderGroup.prototype._removeMapper = function (mapper) {
        var index = this._mappers.indexOf(mapper);
        if (index != -1)
            this._mappers.splice(index, 1);
    };
    /**
     *
     */
    RenderGroup.prototype.onSizeInvalidate = function (event) {
        this.dispatchEvent(event);
    };
    /**
     * Assign the context once retrieved
     */
    RenderGroup.prototype.onContextUpdate = function (event) {
        this.dispatchEvent(event);
    };
    RenderGroup.prototype.getRenderElements = function (elements) {
        var el = this._materialPools[elements.assetType];
        /**
         * @todo Remove me to prevent leaks
         */
        if (!el) {
            el =
                this._materialPools[elements.assetType] =
                    new RenderGroup._renderElementsClassPool[elements.assetType](this.stage, this._materialClassPool, this);
        }
        return el;
    };
    RenderGroup.prototype.requestAbstraction = function (asset) {
        return RenderEntity;
    };
    RenderGroup.prototype.getRenderer = function (partition) {
        return partition.getAbstraction(this._rendererPool);
    };
    /**
     *
     * @param imageObjectClass
     */
    RenderGroup.registerElements = function (renderElementsClass, elementsClass) {
        RenderGroup._renderElementsClassPool[elementsClass.assetType] = renderElementsClass;
    };
    RenderGroup.registerDefaultMaterial = function (renderMaterialClass, materialClass) {
        DefaultRendererPool.registerMaterial(renderMaterialClass, materialClass);
    };
    RenderGroup.registerDepthMaterial = function (renderMaterialClass, materialClass) {
        DepthRendererPool.registerMaterial(renderMaterialClass, materialClass);
    };
    RenderGroup.registerDistanceMaterial = function (renderMaterialClass, materialClass) {
        DistanceRendererPool.registerMaterial(renderMaterialClass, materialClass);
    };
    RenderGroup._rendererPool = (_a = {},
        _a[RendererType.DEFAULT] = DefaultRendererPool,
        _a[RendererType.DEPTH] = DepthRendererPool,
        _a[RendererType.DISTANCE] = DistanceRendererPool,
        _a);
    RenderGroup._defaultInstancePool = new Object();
    RenderGroup._depthInstancePool = new Object();
    RenderGroup._distanceInstancePool = new Object();
    RenderGroup._instancePool = (_b = {},
        _b[RendererType.DEFAULT] = RenderGroup._defaultInstancePool,
        _b[RendererType.DEPTH] = RenderGroup._depthInstancePool,
        _b[RendererType.DISTANCE] = RenderGroup._distanceInstancePool,
        _b);
    RenderGroup._renderElementsClassPool = new Object();
    return RenderGroup;
}(EventDispatcher));
export { RenderGroup };
